var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 16.469q-.25 0-.469-.078a1.1 1.1 0 0 1-.406-.266l-4.5-4.5q-.375-.375-.36-.875t.36-.875q.375-.375.89-.39.516-.016.891.359l2.344 2.344V3.25q0-.531.36-.89Q11.468 2 12 2t.89.36.36.89v8.938l2.344-2.344q.375-.375.89-.36.516.015.891.391.344.375.36.875.015.5-.36.875l-4.5 4.5q-.187.187-.406.266a1.4 1.4 0 0 1-.469.078M4.5 22a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 2 19.5V17q0-.531.36-.89.359-.36.89-.36t.89.36q.36.359.36.89v2.5h15V17q0-.531.36-.89.359-.36.89-.36t.89.36.36.89v2.5q0 1.032-.734 1.766T19.5 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutline);
export default __webpack_public_path__ + "static/media/download_outline.cd362079e36cc2d02fc7566a58ba85e3.svg";
export { ForwardRef as ReactComponent };